<template>
  <div class="modal fade" ref="mdlEtiquetas" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" style="border: none">
        <div class="modal-header text-white bg-success d-flex justify-content-between">
          <div class="modal-title text-center">
            <strong class="font-size-22">
              Etiquetas
              (
                {{ cliente.nombre }}
                {{ cliente.apellido_paterno }}
                {{ cliente.apellido_materno }}
              )
            </strong>
          </div>
          <button class="btn btn-link text-white p-0" @click="cerrarModal()">
            <i class="mdi mdi-close mdi-24px"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <filtrador
                v-on:dato-actualizado="
                  dato = $event,
                  refrescarEtiquetas()
                "
                :datoini="dato"
                placeholder="Nombre de la etiqueta"
              ></filtrador>
            </div>
            <div class="col-md-6 mb-2 text-end">
              <button class="btn btn-secondary" @click="nuevo = !nuevo">
                <span class="d-none d-sm-block">
                  <i class="mdi mdi-plus"></i>
                  Nuevo
                </span>
                <span class="d-block d-sm-none">
                  <i class="mdi mdi-plus"></i>
                </span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="table-responsive">
                <table class="table mb-0 table-nowrap align-middle">
                  <thead>
                    <tr>
                      <th colspan="2">Disponibles</th>
                      <th class="text-center" style="width: 50px;">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="nuevo" class="fila-nueva">
                      <td style="width: 50px;">
                        <input
                          class="form-control text-center form-control-sm color-picker"
                          v-model="color" type="color" title="Color de la etiqueta"
                        />
                      </td>
                      <td>
                        <input
                          ref="nombre" class="form-control form-control-sm"
                          type="text" v-model="nombre" @keyup.enter="guardar()"
                          placeholder="Nombre de la etiqueta"
                        />
                      </td>
                      <td class="text-end">
                        <button 
                          class="btn btn-success btn-sm me-1" 
                          @click="guardar()" title="Guardar nueva etiqueta"
                        >
                          <i class="mdi mdi-content-save"></i>
                        </button>
                        <button 
                          class="btn btn-danger btn-sm"
                          @click="limpiar()" title="Cerrar nueva etiqueta"
                        >
                          <i class="mdi mdi-close"></i>
                        </button>
                      </td>
                    </tr>
                    <tr 
                      v-for="etiqueta in etiquetas_filtradas" 
                      :class="{
                        'fila-edicion': etiqueta.edicion && !etiqueta.eliminar,
                        'fila-eliminacion': etiqueta.eliminar
                      }"
                      :key="etiqueta.id"
                    >
                      <td style="width: 50px;">
                        <input
                          class="form-control text-center form-control-sm color-picker"
                          v-model="etiqueta.color" type="color" v-if="etiqueta.edicion"
                        />
                        <span
                          class="color-circle" v-if="!etiqueta.edicion"
                          :style="{ backgroundColor: etiqueta.color }"
                        ></span>
                      </td>
                      <td>
                        <input
                          :ref="'nombre_'+etiqueta.id" class="form-control form-control-sm"
                          type="text" v-model="etiqueta.nombre" placeholder="Nombre de la etiqueta"
                          v-if="etiqueta.edicion"
                        />
                        <h6 v-if="!etiqueta.edicion" class="text-truncate" :title="etiqueta.nombre">
                          {{ etiqueta.nombre }}
                        </h6>
                      </td>
                      <td class="text-end">
                        <template v-if="etiqueta.edicion && !etiqueta.eliminar">
                          <button class="btn btn-success btn-sm me-1" @click="actualizar(etiqueta)">
                            <i class="mdi mdi-content-save"></i>
                          </button>
                          <button 
                            class="btn btn-danger btn-sm"
                            @click="
                              etiqueta.edicion = !etiqueta.edicion,
                              refrescarEtiquetas()
                            "
                          >
                            <i class="mdi mdi-close"></i>
                          </button>
                        </template>

                        <template v-if="!etiqueta.edicion && !etiqueta.eliminar">
                          <button
                            class="btn btn-warning btn-sm me-1"
                            @click="etiqueta.edicion = !etiqueta.edicion"
                          >
                            <i class="mdi mdi-content-save-edit-outline"></i>
                          </button>
                          <button class="btn btn-danger btn-sm me-1" @click="etiqueta.eliminar = !etiqueta.eliminar">
                            <i class="mdi mdi-trash-can-outline"></i>
                          </button>
                          <button class="btn btn-primary btn-sm" @click="agregarEtiqueta(etiqueta)">
                            <i class="mdi mdi-chevron-double-right"></i>
                          </button>
                        </template>

                        <template v-if="etiqueta.eliminar">
                          <button class="btn btn-success btn-sm me-1" @click="eliminar(etiqueta.id)" title="Eliminar la etiqueta">
                            <i class="mdi mdi-check-bold"></i>
                            Si
                          </button>
                          <button class="btn btn-danger btn-sm" @click="etiqueta.eliminar = !etiqueta.eliminar" title="No eliminar la etiqueta">
                            <i class="mdi mdi-close"></i>
                            No
                          </button>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-6">
              <div class="table-responsive">
                <table class="table mb-0 align-middle table-nowrap">
                  <thead>
                    <tr>
                      <th colspan="2">Asignados al cliente</th>
                      <th class="text-center" style="width: 50px;">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="etiqueta in etiquetas_cliente"
                      :class="{
                        'fila-edicion': etiqueta.edicion && !etiqueta.eliminar,
                        'fila-eliminacion': etiqueta.eliminar
                      }"
                      :key="etiqueta.id"
                    >
                      <td style="width: 50px;">
                        <input
                          class="form-control text-center form-control-sm color-picker"
                          v-model="etiqueta.color" type="color" v-if="etiqueta.edicion"
                        />
                        <span
                          class="color-circle" v-if="!etiqueta.edicion"
                          :style="{ backgroundColor: etiqueta.color }"
                        ></span>
                      </td>
                      <td>
                        <input
                          :ref="'nombre_'+etiqueta.id" class="form-control form-control-sm"
                          type="text" v-model="etiqueta.nombre" placeholder="Nombre de la etiqueta"
                          v-if="etiqueta.edicion"
                        />
                        <h6 v-if="!etiqueta.edicion" class="text-truncate" :title="etiqueta.nombre">
                          {{ etiqueta.nombre }}
                        </h6>
                      </td>
                      <td class="text-end">
                        <template v-if="etiqueta.edicion && !etiqueta.eliminar">
                          <button class="btn btn-success btn-sm me-1" @click="actualizar(etiqueta)">
                            <i class="mdi mdi-content-save"></i>
                          </button>
                          <button 
                            class="btn btn-danger btn-sm"
                            @click="
                              etiqueta.edicion = !etiqueta.edicion,
                              refrescarEtiquetas()
                            "
                          >
                            <i class="mdi mdi-close"></i>
                          </button>
                        </template>
                        <template v-if="!etiqueta.edicion && !etiqueta.eliminar">
                          <button 
                            class="btn btn-warning btn-sm me-1"
                            @click="etiqueta.edicion = !etiqueta.edicion"
                          >
                            <i class="mdi mdi-content-save-edit-outline"></i>
                          </button>
                          <button class="btn btn-danger btn-sm me-1" @click="etiqueta.eliminar = !etiqueta.eliminar">
                            <i class="mdi mdi-trash-can-outline"></i>
                          </button>
                          <button class="btn btn-primary btn-sm" @click="quitarEtiqueta(etiqueta)">
                            <i class="mdi mdi-chevron-double-left"></i>
                          </button>
                        </template>
                        <template v-if="etiqueta.eliminar">
                          <button class="btn btn-success btn-sm me-1" @click="eliminar(etiqueta.id)" title="Eliminar la etiqueta">
                            <i class="mdi mdi-check-bold"></i>
                            Si
                          </button>
                          <button class="btn btn-danger btn-sm" @click="etiqueta.eliminar = !etiqueta.eliminar" title="No eliminar la etiqueta">
                            <i class="mdi mdi-close"></i>
                            No
                          </button>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-light" @click="cerrarModal()">
            <i class="mdi mdi-close"></i>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filtrador from '@/components/Filtrador.vue'
import Modal from 'bootstrap/js/dist/modal'
import EtiquetaClientesSrv from '@/services/EtiquetaClientesSrv'
import ClienteSrv from '@/services/ClienteSrv.js'

export default {
  name: 'MdlEtiquetas',
  components: {
    Filtrador
  },
  data() {
    return {
      modalInstance: null,

      dato: '',

      nuevo: false,
      color: '#63AD6F',
      nombre: '',

      id_cliente: null,
      cliente: {
        id: null, 
        nombre: '',
        apellido_paterno: '',
        apellido_materno: ''
      },

      etiquetas_cliente: [],
      etiquetas: []
    }
  },
  computed: {
    etiquetas_filtradas: function() {
      let idsAsignados = new Set(
        this.etiquetas_cliente.map(e => e.id)
      )

      return this.etiquetas.filter(etiqueta => !idsAsignados.has(etiqueta.id))
    }
  },
  methods: {
    actualizar: function(etiqueta) {
      var self = this

      if(etiqueta.nombre == '') {
        iu.msg.warning("Se necesita un nombre para la etiqueta")
        this.$nextTick(() => {
          let ref = this.$refs['nombre_' + idEtiqueta]
          let input = Array.isArray(ref) ? ref[0] : ref
          input?.focus()
        })
        return
      }

      EtiquetaClientesSrv.actualizar(etiqueta).then(response => {
        iu.msg.success("Se actualizo correctamente la etiqueta")
        self.refrescarEtiquetas()
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo actualizar la etiqueta'
        iu.msg.error(mensaje)
        console.error(error)
      }).finally(() => {
        self.$emit('cargar:cliente')
      })
    },

    cerrarModal() {
      document.activeElement?.blur() // Quita el foco del botón actual
      if(this.modalInstance) this.modalInstance.hide()
    },

    eliminar: function(idEtiqueta) {
      var self = this

      EtiquetaClientesSrv.eliminar(idEtiqueta).then(response => {
        iu.msg.success("Se elimino correctamente la etiqueta")
        self.refrescarEtiquetas()
        self.$emit('cargar:cliente')
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo eliminar la etiqueta'
        iu.msg.error(mensaje)
        console.error(error)
      })
    },

    guardar: function() {
      var self = this

      if(self.nombre == '') {
        iu.msg.warning("Se necesita un nombre para la etiqueta")
        self.$refs.nombre.focus()
        return
      }

      let newEtiqueta = {
        color: self.color,
        nombre: self.nombre
      }

      EtiquetaClientesSrv.guardar(newEtiqueta).then(response => {
        iu.msg.success("Se guardo correctamente la nueva etiqueta")
        self.refrescarEtiquetas()
        self.limpiar()
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo guardar la etiqueta'
        iu.msg.error(mensaje)
        console.error(error)
      })
    },

    limpiar: function() {
      var self = this
      
      self.nuevo = false
      self.color = '#63AD6F'
      self.nombre = ''
    },

    mostrar: function(idCliente) {
      let self = this

      self.id_cliente = idCliente

      self.cargarCliente()
      self.refrescarEtiquetas()

      self.modalInstance.show()
    },

    cargarCliente: function() {
      var self = this

      ClienteSrv.clienteJSON(self.id_cliente).then(response => {
        self.cliente = response.data
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar el cliente'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarEtiquetas: function() {
      var self = this,
        params = {
          dato: self.dato,
          sin_usar: true
        }

      EtiquetaClientesSrv.etiquetasJSON(params).then(response => {
        let etiquetas = response.data

        etiquetas.map(function(etiqueta) {
          etiqueta.edicion = false
          etiqueta.eliminar = false
          return etiqueta
        })

        self.etiquetas = etiquetas
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se cargaron las etiquetas'
        iu.msg.error(mensaje)
        console.error(error)
      })
    },

    cargarEtiquetasCliente: function() {
      var self = this,
        params = {
          dato: self.dato
        }

      ClienteSrv.etiquetasJSON(self.id_cliente, params).then(response => {
        let etiquetas = response.data

        etiquetas.map(function(etiqueta) {
          etiqueta.edicion = false
          etiqueta.eliminar = false
          return etiqueta
        })

        self.etiquetas_cliente = etiquetas
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se cargaron las etiquetas del cliente'
        iu.msg.error(mensaje)
        console.error(error)
      })
    },

    refrescarEtiquetas: function() {
      this.cargarEtiquetas()
      this.cargarEtiquetasCliente()
    },

    agregarEtiqueta: function(etiqueta) {
      var self = this

      let existe = self.etiquetas_cliente.find(e => {
        return e.id == etiqueta.id
      })

      if(existe) {
        iu.msg.warning("Ya existe esta etiqueta ligada al cliente")
        return
      }

      ClienteSrv.agregarEtiqueta(self.id_cliente, etiqueta.id).then(response => {
        iu.msg.success("Se agrego la etiqueta correctamente")
        self.$emit('cargar:cliente')
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo agregar la etiqueta al cliente'
        iu.msg.error(mensaje)
        console.error(error)
      }).finally(() => {
        self.refrescarEtiquetas()
      })
    },

    quitarEtiqueta: function(etiqueta) {
      self = this

      ClienteSrv.quitarEtiqueta(self.id_cliente, etiqueta.id).then(response => {
        iu.msg.success("Se quito la etiqueta correctamente")
        self.$emit('cargar:cliente')
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo quitar la etiqueta al cliente'
        iu.msg.error(mensaje)
        console.error(error)
      }).finally(() => {
        self.refrescarEtiquetas()
      })
    },
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.mdlEtiquetas)
  }
}
</script>

<style scoped>
.color-circle {
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid #e9ecef;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.05);
}

.color-picker {
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 50%;
  border: 2px solid #e9ecef;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.05);
  overflow: hidden;
  cursor: pointer;
}

/* Quitar estilos feos internos en algunos navegadores */
.color-picker::-webkit-color-swatch-wrapper {
  padding: 0;
}

.color-picker::-webkit-color-swatch {
  border: none;
  border-radius: 50%;
}

/* Firefox */
.color-picker::-moz-color-swatch {
  border: none;
  border-radius: 50%;
}

/* para un nuevo etiqueta */
.fila-nueva {
  background-color: #e7f1ff; /* azul suave */
  border-left: 4px solid #0d6efd; /* estilo bootstrap */
  transition: background-color 0.2s ease;
}

.fila-nueva:hover {
  background-color: #d3e5ff; /* un poco más fuerte al pasar el mouse */
}

/* Aplica estilos SOLO a inputs que NO sean tipo color */
.fila-nueva input:not([type="color"]) {
  background-color: #ffffff;
  border-color: #0d6efd;
}

/* para edicion etiqueta */
.fila-edicion {
  background-color: #fff3cd; /* amarillo suave tipo warning */
  border-left: 4px solid #ffc107; /* bootstrap warning */
  transition: background-color 0.2s ease;
}
.fila-edicion:hover {
  background-color: #ffe8a1;
}
/* Solo inputs normales */
.fila-edicion input:not([type="color"]) {
  background-color: #ffffff;
  border-color: #ffc107;
}

/* para eliminacion etiqueta */
.fila-eliminacion {
  background-color: #f8d7da; /* rojo suave tipo danger */
  border-left: 4px solid #dc3545; /* bootstrap danger */
  transition: background-color 0.2s ease;
}

.fila-eliminacion:hover {
  background-color: #f1aeb5;
}

/* Solo inputs normales */
.fila-eliminacion input:not([type="color"]) {
  background-color: #ffffff;
  border-color: #dc3545;
}

.fila-eliminacion td {
  text-decoration: line-through; /* opcional tipo "marcado para borrar" */
}

.fila-eliminacion {
  animation: shake 0.2s ease-in-out;
}

@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-2px); }
  50% { transform: translateX(2px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}

.text-truncate {
  width: 170px;
}
</style>